import React from "react";
import ReactDOM from "react-dom";
import "assets/css/App.css";
import {
  Route,
  Switch,
  Redirect,
  BrowserRouter,
} from "react-router-dom";
import AuthLayout from "layouts/auth";
import AdminLayout from "layouts/admin";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "theme/theme";
import { ThemeEditorProvider } from "@hypertheme-editor/chakra-ui";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';


ReactDOM.render(
  <ChakraProvider theme={theme}>
    <React.StrictMode>
      <ToastContainer autoClose={3000}/>
      <ThemeEditorProvider>
        <BrowserRouter>
          <Switch>
            <Route path={`/admin`} component={AdminLayout} />
            <Route path={`/auth`} component={AuthLayout} />
            <Redirect from="/" to="/auth" />
          </Switch>
        </BrowserRouter>
      </ThemeEditorProvider>
    </React.StrictMode>
  </ChakraProvider>,
  document.getElementById("root")
);
